import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["visible", "show", "hide"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import compose from 'recompose/compose';
import withStateHandlers from 'recompose/withStateHandlers';
import pure from 'recompose/pure';
import mapProps from 'recompose/mapProps';
import PropTypes from 'prop-types';
var withVisibleState = function withVisibleState() {
  var initialVisibleValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return compose(withStateHandlers({
    visible: initialVisibleValue
  }, {
    show: function show() {
      return function () {
        return {
          visible: true
        };
      };
    },
    hide: function hide() {
      return function () {
        return {
          visible: false
        };
      };
    }
  }), mapProps(function (_ref) {
    var visible = _ref.visible,
      show = _ref.show,
      hide = _ref.hide,
      restProps = _objectWithoutProperties(_ref, _excluded);
    return _objectSpread(_objectSpread({}, restProps), {}, {
      visibleHandler: {
        visible: visible,
        show: show,
        hide: hide
      }
    });
  }), pure);
};
export default withVisibleState;
export var propTypes = {
  visibleHandler: PropTypes.shape({
    visible: PropTypes.bool.isRequired,
    show: PropTypes.func.isRequired,
    hide: PropTypes.func.isRequired
  }).isRequired
};